module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Medium.e7a6e3cf.eot";